import { useStore } from "../store/useStore";
import { t } from "../lib/i18n";

type Props = {
  variant?: "dark" | "light";
  size?: "lg" | "md";
  className?: string;
};

export function CardOnlyBanner({ variant = "light", size = "md", className = "" }: Props) {
  const lang = useStore((s) => s.language);
  const dark = variant === "dark";
  const big = size === "lg";

  return (
    <div
      className={`relative inline-flex items-center gap-4 px-6 py-3 border-[3px] ${
        dark ? "bg-mango text-ink border-ink" : "bg-ink text-mango border-mango"
      } ${className}`}
      style={{ transform: "rotate(-1.2deg)" }}
    >
      <span className={`text-3xl ${big ? "md:text-5xl" : ""}`}>💳</span>
      <div className="flex flex-col leading-none">
        <span className={`font-display font-black ${big ? "text-3xl md:text-5xl" : "text-2xl"} tracking-kerned`}>
          {t(lang, "card_only_main")}
        </span>
        <span className={`font-mono ${big ? "text-sm md:text-base" : "text-[11px]"} tracking-[0.3em] opacity-80 mt-1`}>
          {t(lang, "card_only_sub")}
        </span>
      </div>
      <span className="text-3xl opacity-60 line-through">💵</span>
      <span className="absolute -top-2 -left-2 w-3 h-3 bg-current rounded-full" />
      <span className="absolute -top-2 -right-2 w-3 h-3 bg-current rounded-full" />
      <span className="absolute -bottom-2 -left-2 w-3 h-3 bg-current rounded-full" />
      <span className="absolute -bottom-2 -right-2 w-3 h-3 bg-current rounded-full" />
    </div>
  );
}
